export const showCardDetails = (hasAdministerBillingPermission, hasAccountBalance, estimatedTotal, accountBalance, isTermsUser) => (
  hasAdministerBillingPermission
      && (!hasAccountBalance || estimatedTotal > accountBalance)
      && estimatedTotal !== 0 && !isTermsUser
);

export const getFooterData = (
  hasAdministerBillingPermission,
  isTermsUser,
  isBilledInBulk,
  hasAccountBalance,
  estimatedTotal,
  accountBalance,
  t,
) => {
  const footer = {
    paymentOption: '',
    planType: '',
    subText: '',
    billingMaster: '',
    boldText: '',
  };

  if (isTermsUser && !isBilledInBulk && !hasAdministerBillingPermission) {
    footer.subText = t('finalize_order__payment_information__terms_with_master_billing');
    return footer;
  }

  if (!hasAdministerBillingPermission) {
    footer.billingMaster = t('finalize_order__payment_information__master_billing');
  }
  if (hasAccountBalance && estimatedTotal <= accountBalance) {
    footer.paymentOption = t('finalize_order__payment_information__payment_option');
    footer.subText = t('finalize_order__payment_information__has_prepay_balance');
    footer.planType = t('finalize_order__payment_information__prepay');
  } else if (isTermsUser) {
    footer.subText = t('finalize_order__payment_information__has_prepay_balance');
  } else {
    footer.subText = t('finalize_order__payment_information__creditcardauth');
    if (hasAccountBalance) {
      footer.boldText = t('finalize_order__payment_information__creditcardauth_with_balance');
    }
  }

  return footer;
};
